import { render, staticRenderFns } from "./AdminEditStaff.vue?vue&type=template&id=49b4572b&scoped=true&"
import script from "./AdminEditStaff.vue?vue&type=script&lang=js&"
export * from "./AdminEditStaff.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditStaff.vue?vue&type=style&index=0&id=49b4572b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b4572b",
  null
  
)

export default component.exports